module.exports = "/build/web/svg/icon-arrow-right--dark.ea3561f0a284e771db50df0bc8a6a6de.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-arrow-right--dark.svg
// module id = 116
// module chunks = 13